import React from 'react';
import { createRoot } from 'react-dom/client';
import '../../src/styles/product-details.less';
import ProductDetailsWrapper from '../../src/js/exhibitorDetails/ProductDetailsWrapper';
import { authController } from '@reedexpo/authorization-component-ui';
import { HashRouter } from 'react-router-dom';

if (global.window && global.window.document) {
  const { props, elementId, idpUrl } = window.reactSettings || window.reactSettingsProductDetails;
  const propsForChildren = Object.assign({}, props, { idpUrl: props.idpUrl || idpUrl });
  const authSettings = window.authSettings;
  if (authSettings && authSettings.usePkce) {
    authController.initialize(authSettings);
  }
  const container = document.getElementById(elementId);
  const root = createRoot(container);
  root.render(<HashRouter><ProductDetailsWrapper {... propsForChildren} /></HashRouter>);
}
